
import { defineComponent } from "vue";
import AppSlide from "./app-slide.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/apps/bty-seo-pc/stores/app";

export default defineComponent({
  props: {
    btyUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    style() {
      const { scrollTop } = this;
      const start = 504;
      const min = 0.92;
      let opacity = 0.8;
      if (scrollTop < start) {
        return { transform: `scale(${min})`, opacity };
      }
      const top = scrollTop - start;
      const delta = 0.00025;
      const scale = Math.min(top * delta + min, 1);
      const opacityDelta = top * 0.001;
      const o = Math.min(opacity + opacityDelta, 1);
      return {
        transform: `scale(${scale})`,
        opacity: o,
      };
    },
    textStyle() {
      const { scrollTop } = this;
      const start = 910;
      if (scrollTop < start) {
        return { transform: "translateY(0px)" };
      }
      const top = scrollTop - start;
      const delta = 0.2;
      const y = Math.min(top * delta, 72);
      return { transform: `translateY(${y}px)` };
    },
    girlStyle() {
      const { scrollTop } = this;
      const start = 950;
      if (scrollTop < start) {
        return { transform: "translateY(0px)" };
      }
      const top = scrollTop - start;
      const delta = 0.7;
      const y = Math.min(top * delta, 180);
      return { transform: `translateY(${y}px)` };
    },
    ...mapState(useAppStore, ["scrollTop"]),
  },
  render() {
    return (
      <AppSlide>
        <div class="slide2__box container" style={this.style}>
          <div class="slide2__image-girl" style={this.girlStyle}>
            <img src={require("./pretty-girls.png")} alt="" loading="lazy" />
          </div>
          <div class="slide2__text-content" style={this.textStyle}>
            <div class="slide2__live-heading">
              <img
                class="slide2__icon-live"
                src={require("./icon-live.svg")}
                alt=""
                loading="lazy"
              />
              Live match
            </div>
            <h2>全球赛事直播</h2>
            <h3>美女主播解说 精彩绝不停歇</h3>
            <p class="desc">
              Live broadcast of global events, live broadcast of beautiful
              women's commentary on the competition, and non-stop broadcast of
              exciting events
            </p>
            <a class="btn btn-primary" href={this.btyUrl} target="_blank">
              立即体验
              <img src={require("./arrow-right.svg")} alt="" />
            </a>
          </div>
        </div>
      </AppSlide>
    );
  },
});
